import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'idp-input-icon-toggle',
  templateUrl: './input-icon-toggle.component.html',
  encapsulation: ViewEncapsulation.None
})
export class InputIconToggleComponent {
  isToggleIcon = false;

  @Input() ariaLabel = 'Demo input';
  @Input() labelTxt = 'Demo Label Placeholder';
  @Input() topLabelText = 'Demo Label';

  constructor() {
    //do nothing
  }

  clickEvent() {
    this.isToggleIcon = !this.isToggleIcon;
  }
}
